import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

/**
 * Sets the browser/document title from the active route's `title` property.
 *
 * Committee routes get the `CM - ` prefix they always had. Vault routes do not: they set their
 * own fully-formed titles ("Sign in — Family Vault"), and prefixing produced
 * "CM - Sign in — Family Vault" — the branding of the module the vault is replacing, on every
 * one of its tabs.
 */
@Injectable({ providedIn: 'root' })
export class CmTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) { super(); }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const page = this.buildTitle(snapshot);

    if (!page) {
      this.title.setTitle('CM');
      return;
    }

    const isVault = snapshot.url.startsWith('/vault');
    this.title.setTitle(isVault ? page : `CM - ${page}`);
  }
}
